
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M17.9172 12.4379V8.08877C17.9172 6.47393 17.2757 4.92522 16.1338 3.78336C14.992 2.64149 13.4433 2 11.8284 2C10.2136 2 8.66487 2.64149 7.52301 3.78336C6.38114 4.92522 5.73965 6.47393 5.73965 8.08877V12.4379C5.71378 14.5864 5.11309 16.6888 4 18.5267H19.6568C18.5437 16.6888 17.9431 14.5864 17.9172 12.4379Z"></path><path d="M10.6126 21.1144C10.4702 21.014 10.3417 20.8969 10.2293 20.7663H13.4275C13.3152 20.8969 13.1866 21.014 13.0442 21.1144C12.6885 21.3653 12.2638 21.5 11.8284 21.5C11.3931 21.5 10.9684 21.3653 10.6126 21.1144Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiNotify",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
